/**
 * True if setSinkId exists on a fresh <audio> or on HTMLMediaElement.prototype.
 * Some Chromium builds only attach it one of those places; checking both avoids
 * hiding the speaker UI on Android Chrome.
 */
export function supportsAudioElementSetSinkId() {
  if (typeof document === "undefined") return false;
  try {
    const a = document.createElement("audio");
    const onInstance = typeof a.setSinkId === "function";
    const onProto =
      typeof HTMLMediaElement !== "undefined" &&
      typeof HTMLMediaElement.prototype?.setSinkId === "function";
    return Boolean(onInstance || onProto);
  } catch {
    return false;
  }
}

/**
 * Stock Chrome (or Chromium) on Android — not WebView, Samsung Internet, Firefox, etc.
 * Used to still show the output picker when feature detection is overly strict
 * (e.g. HTTP dev URL, or setSinkId only appears on live playback elements).
 */
export function isLikelyAndroidChrome() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (!/Android/i.test(ua)) return false;
  if (/; wv\)/i.test(ua) || /\bwv\b.*Chrome/i.test(ua)) return false;
  if (!/Chrome\/\d/i.test(ua)) return false;
  if (
    /Firefox|FxiOS|OPR\/|Opera Mini|EdgA|SamsungBrowser|UCBrowser|QQBrowser|MiuiBrowser/i.test(
      ua
    )
  ) {
    return false;
  }
  return true;
}

/** Show speaker/output dropdown: API detected, or Android Chrome where routing often works. */
export function shouldOfferAudioOutputPicker() {
  return supportsAudioElementSetSinkId() || isLikelyAndroidChrome();
}

/** Whether to run the effect that calls setSinkId on meeting <audio> elements. */
export function shouldTryApplyAudioSink() {
  return supportsAudioElementSetSinkId() || isLikelyAndroidChrome();
}
